var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('app-drawer',{attrs:{"menus":_vm.menus,"color":"light-blue darken-4"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }